import { render, staticRenderFns } from "./HomeBonuses.vue?vue&type=template&id=c697b8b2&"
import script from "./HomeBonuses.vue?vue&type=script&lang=js&"
export * from "./HomeBonuses.vue?vue&type=script&lang=js&"
import style0 from "./HomeBonuses.vue?vue&type=style&index=0&id=c697b8b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports